import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { 
    activeTab: { type: String, default: "countries" }
  }

  connect() {
    console.log("📊 Analytics tabs controller connected")
    this.showTab(this.activeTabValue)
  }

  // Action triggered by tab button clicks
  switch(event) {
    event.preventDefault()
    const tabName = event.currentTarget.dataset.tab
    this.showTab(tabName)
  }

  showTab(tabName) {
    // Hide all panels
    this.panelTargets.forEach(panel => {
      panel.classList.add('hidden')
    })

    // Deactivate all tabs
    this.tabTargets.forEach(tab => {
      tab.classList.remove('bg-beb-surface', 'text-beb-accent-text', 'shadow-sm')
      tab.classList.add('text-beb-fg-2')
    })

    // Show selected panel
    const selectedPanel = this.panelTargets.find(
      panel => panel.dataset.tab === tabName
    )
    if (selectedPanel) {
      selectedPanel.classList.remove('hidden')
    }

    // Activate selected tab
    const selectedTab = this.tabTargets.find(
      tab => tab.dataset.tab === tabName
    )
    if (selectedTab) {
      selectedTab.classList.add('bg-beb-surface', 'text-beb-accent-text', 'shadow-sm')
      selectedTab.classList.remove('text-beb-fg-2')
    }

    // Update active value
    this.activeTabValue = tabName
  }

  disconnect() {
    console.log("📊 Analytics tabs controller disconnected")
  }
}
